export {default as Dashboard} from './Dashboard'
export {default as Stock} from './Stock'
export {default as Data} from './Data'
export {default as Help} from './Help'
export {default as Contact} from './Contact'